<template>
  <div class="w-full overflow-auto">
    <TimetableTimeline />
    <div class="flex" :style="styles">
      <TimetableSidebar />
      <div class="flex flex-col">
        <TimetableRow :month="month" v-for="(month, $i) in months" :key="$i" />
      </div>
    </div>
  </div>
</template>

<script>
import TimetableTimeline from '@/components/Timetable/TimetableTimeline'
import TimetableRow from '@/components/Timetable/TimetableRow'
import TimetableSidebar from '@/components/Timetable/TimetableSidebar'

import { get } from 'vuex-pathify'

export default {
  name: 'TimetableGantt',

  components: {
    TimetableTimeline,
    TimetableRow,
    TimetableSidebar
  },

  computed: {
    months: get('timetable/months'),
    days: get('timetable/days'),
    totalWeeks: get('timetable/totalWeeks'),

    daysInTotalWeeks() {
      return this.days.slice(0, this.totalWeeks * 7)
    },

    styles() {
      return {
        maxWidth: (this.daysInTotalWeeks.length + 2) * 32 + 160 + 'px'
      }
    }
  }
}
</script>
